/* eslint-disable no-useless-escape */
export function sanitizeTitle(title) {
    return title.normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9\.\-]/gi, '_')
        .replace(/_{2,}/g, '_');
}
